import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AuthCallbackPage() {
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token   = params.get('token');
    const error   = params.get('error');
    const name    = params.get('name');
    const picture = params.get('picture');
    const welcome = params.get('welcome');

    if (error || !token) {
      navigate('/login?error=google_failed', { replace: true });
      return;
    }

    // Decode JWT payload (read-only — verification happens server-side)
    let payload = {};
    try {
      payload = JSON.parse(atob(token.split('.')[1]));
    } catch {
      navigate('/login?error=google_failed', { replace: true });
      return;
    }

    login(token, {
      id:            payload.id,
      email:         payload.email,
      name:          name    ? decodeURIComponent(name)    : payload.name,
      role:          'landlord',
      googlePicture: picture ? decodeURIComponent(picture) : null,
    });

    navigate(welcome === '1' ? '/dashboard?welcome=1' : '/dashboard', { replace: true });
  }, [login, navigate]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-10 h-10 border-2 border-brand-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-slate-500">Signing you in with Google…</p>
      </div>
    </div>
  );
}
